// src/components/modal/tabs/IngredientsTabContent.tsx
import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import type { MenuItem, Branch } from "~/types/new_types";
import { getItemIngredients } from "~/utils/menuItemHelper";

interface IngredientsTabContentProps {
  item: MenuItem;
  theme:
    | Branch["theme"]
    | {
        primaryColor?: string;
        secondaryColor?: string;
        backgroundColor?: string;
        cardColor?: string;
        textColor?: string;
        borderColor?: string;
        borderRadius?: string;
        fontFamily?: string;
      };
  language: string;
}

export const IngredientsTabContent: React.FC<IngredientsTabContentProps> = ({
  item,
  theme,
  language,
}) => {
  const { t } = useTranslation();

  return (
    <motion.div key="ingredients">
      {getItemIngredients(item, language).length > 0 ? (
        <div className="space-y-4">
          <h3 className="font-bold" style={{ color: theme?.textColor }}>
            {t("menu.ingredients")}
          </h3>
          <div className="grid grid-cols-2 gap-3">
            {getItemIngredients(item, language).map((ingredient, index) => (
              <motion.div
                key={index}
                className="px-4 py-2 rounded-lg flex items-center gap-2"
                style={{
                  backgroundColor: `${theme?.primaryColor}10`,
                  borderRadius: theme?.borderRadius,
                }}
                whileHover={{
                  scale: 1.02,
                  backgroundColor: `${theme?.primaryColor}20`,
                }}
              >
                <span
                  className="w-2 h-2 rounded-full flex-shrink-0"
                  style={{
                    backgroundColor: theme?.primaryColor,
                  }}
                ></span>
                <span style={{ color: theme?.textColor }}>{ingredient}</span>
              </motion.div>
            ))}
          </div>
        </div>
      ) : (
        <div
          className="flex flex-col items-center justify-center py-8 text-center"
          style={{ color: `${theme?.textColor}60` }}
        >
          <div className="text-4xl mb-4">🔍</div>
          <p>{t("menuItem.noIngredients")}</p>
        </div>
      )}
    </motion.div>
  );
};
